const Header = () => {
    return (
      <div className="header">
          <h1>MB Social Dashboard</h1>
      </div>
    );
  }
  
  export default Header;
  